import { render, staticRenderFns } from "./PreiviewImg.vue?vue&type=template&id=2b1bbbc4&scoped=true";
import script from "./PreiviewImg.vue?vue&type=script&lang=js";
export * from "./PreiviewImg.vue?vue&type=script&lang=js";
import style0 from "./PreiviewImg.vue?vue&type=style&index=0&id=2b1bbbc4&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "2b1bbbc4", null);
export default component.exports;